<!-- @if (history()) {
  <div class="validation-card">
    <div class="validation-header">
      <h3>Área: {{ history()?.areaId || 'N/A' }}</h3>
    </div>

    <div class="validation-content">
      <div class="validation-section">
        <h4>Informações Gerais</h4>
        <div class="info-grid">
          <div class="info-item">
            <span class="label">Área (ha):</span>
            <span class="value">{{ (history()?.areaHa | number:'1.2-2') || 'N/A' }}</span>
          </div>
          <div class="info-item">
            <span class="label">CPF/CNPJ:</span>
            <span class="value">{{ history()?.cpfCnpj || 'N/A' }}</span>
          </div>
          <div class="info-item">
            <span class="label">Produtor:</span>
            <span class="value">{{ history()?.producer || 'N/A' }}</span>
          </div>
          <div class="info-item">
            <span class="label">Município:</span>
            <span class="value">{{ history()?.ibgeCity?.nmMun || 'N/A' }}</span>
          </div>
          <div class="info-item">
            <span class="label">UF:</span>
            <span class="value">{{ history()?.ibgeCity?.nmUf || 'N/A' }}</span>
          </div>
          <div class="info-item">
            <span class="label">Bioma:</span>
            <span class="value">{{ history()?.biome?.bioma || 'N/A' }}</span>
          </div>
        </div>
      </div>

      @if (history()?.historyCrops && (history()?.historyCrops?.length ?? 0) > 0) {
        <div class="validation-section">
          <h4>Culturas</h4>
          <div class="crops-list">
            @for (crop of history()?.historyCrops; track crop.id) {
              <div class="crop-item">
                <div class="crop-header">
                  <span class="crop-name">{{ crop.crops }}</span>
                </div>
                <div class="cycles-grid">
                  @if (crop.cycle1) {
                    <div class="cycle-item">
                      <span class="cycle-label">Ciclo 1:</span>
                      <span class="cycle-value">{{ crop.cycle1 }}</span>
                      @if (crop.areaCycle1) {
                        <span class="area-value">({{ crop.areaCycle1 }} ha)</span>
                      }
                      @if (crop.droughtCycle1) {
                        <span class="drought-indicator">🌵 Seca</span>
                      }
                    </div>
                  }
                  @if (crop.cycle2) {
                    <div class="cycle-item">
                      <span class="cycle-label">Ciclo 2:</span>
                      <span class="cycle-value">{{ crop.cycle2 }}</span>
                      @if (crop.areaCycle2) {
                        <span class="area-value">({{ crop.areaCycle2 }} ha)</span>
                      }
                      @if (crop.droughtCycle2) {
                        <span class="drought-indicator">🌵 Seca</span>
                      }
                    </div>
                  }
                  @if (crop.cycle3) {
                    <div class="cycle-item">
                      <span class="cycle-label">Ciclo 3:</span>
                      <span class="cycle-value">{{ crop.cycle3 }}</span>
                      @if (crop.areaCycle3) {
                        <span class="area-value">({{ crop.areaCycle3 }} ha)</span>
                      }
                      @if (crop.droughtCycle3) {
                        <span class="drought-indicator">🌵 Seca</span>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }

      @if (history()?.historyUses && (history()?.historyUses?.length ?? 0) > 0) {
        <div class="validation-section">
          <h4>Uso do Solo</h4>
          <div class="uses-list">
            @for (use of history()?.historyUses; track use.id) {
              <div class="use-item">
                <div class="use-info">
                  <span class="use-class">{{ use.className || use.classCode || 'N/A' }}</span>
                  @if (use.areaHa) {
                    <span class="use-area">({{ use.areaHa | number:'1.2-2' }} ha)</span>
                  }
                  @if (use.currentSeason) {
                    <span class="use-season">- Safra {{ use.currentSeason }}</span>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
} -->

<section class="details-info-container">
  <div class="detail">
    <h2>Detalhes</h2>
  </div>

  <div class="info">
    <div class="info-item">
      <p>Solicitante</p>
      <span>{{ validation()?.createdByUser?.name }}</span>
    </div>

    <div class="inputs">
      <div class="input">
        <p class="label">Arquivo</p>
        <a class="link" [href]="validation()?.fileDownloadLink">{{
          validation()?.originalFileName || validation()?.gcsFileName
        }}</a>
      </div>

      <div class="input">
        <p class="label">Nº de relatórios da solicitação</p>
        <span class="info-text"
          >{{ validation()?.featureCount }} relatórios</span
        >
      </div>

      <div class="input">
        <p class="label">Data da inserção</p>
        <span class="info-text">{{ validation()?.createdDate | date }}</span>
      </div>
    </div>

    <div class="inputs">
      <div class="input">
        <p class="label">Inconsistências</p>
        <a class="link" [href]="validation()?.validationDetailDownloadLink">{{
          validation()?.autoValidationDetailFileName
        }}</a>
      </div>

      <div class="input">
        <p class="label">Parecer DataSafra</p>
        <mat-radio-group disabled [value]="validation()?.autoValidationSuccess">
          <mat-radio-button [value]="true">Consistente</mat-radio-button>
          <mat-radio-button [value]="false">Inconsistente</mat-radio-button>
        </mat-radio-group>
      </div>
      @if (validation()?.generatedGcsFileName !== null) {
        <div class="input">
          <p class="label">Arquivo Gerado</p>
          <a class="link" [href]="validation()?.generatedFileDownloadLink">{{
            validation()?.generatedGcsFileName
          }}</a>
        </div>
      }
    </div>
  </div>
</section>
